import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { documentsActions } from '../../../application/actions/documents';
import { loadingActions } from '../../../application/actions/ui_loaders';
// import {getDocumentoMock} from './responseMock'

import api from '../../api';

const apiDocuments = api(process.env.REACT_APP_DOCUMENTS_API);

export function* fetchGenericDocuments(action) {
  try {
    yield put(loadingActions.changeStatusLoadingDocuments({isLoading: true, name: action.payload.nombre }));
    const response =  yield call(apiDocuments.post, 'v1/generar',action.payload)   // getDocumentoMock(action.payload.nombre) ;
    const { data } = response;
    /* istanbul ignore next */
    if (data)
      /* istanbul ignore next */
      yield all([
        put(documentsActions.fetchGenericDocumentsSuccess(data)),
        put(loadingActions.changeStatusLoadingDocuments({ isLoading: false, name: action.payload.nombre })),
      ]);
    else
    /* istanbul ignore next */
      yield all([
        put(documentsActions.fetchGenericDocumentsError(response.error)),
        put(loadingActions.changeStatusLoadingDocuments({ isLoading:false, name: action.payload.nombre })),
      ]);
  } catch (err) {
    yield all([
      put(documentsActions.fetchGenericDocumentsError({ code: 500 })),
      put(loadingActions.changeStatusLoadingDocuments({ isLoading: false, name: action.payload.nombre })),
    ]);
  }
}

export function* fetchCustomDocuments(action) {
  try {
    yield put(loadingActions.changeStatusLoadingDocuments({ isLoading: true }));

    const { data, error } = yield call(apiDocuments.post,'v1/generar',action.payload);
    /* istanbul ignore next */
    if (data)
      /* istanbul ignore next */
      yield all([
        put(documentsActions.fetchCustomDocumentsSuccess(data)),
        put(loadingActions.changeStatusLoadingDocuments({ isLoading: false })),
      ]);
    else
    /* istanbul ignore next */
      yield all([
        put(documentsActions.fetchCustomDocumentsError(error)),
        put(loadingActions.changeStatusLoadingDocuments({ isLoading: false })),
      ]);
  } catch (err) {
    yield all([
      put(documentsActions.fetchCustomDocumentsError({ code: 500 })),
      put(loadingActions.changeStatusLoadingDocuments({ isLoading: false })),
    ])
  }
}

export function* watchFetchGenericDocumentst() {
  yield takeLatest(documentsActions.fetchGenericDocuments.type, fetchGenericDocuments);
}

export function* watchFetchCustomDocumentst() {
  yield takeLatest(documentsActions.fetchCustomDocuments.type, fetchCustomDocuments);
}
/* istanbul ignore next */
export default function* contractsSaga() {
  yield spawn(watchFetchGenericDocumentst);
  yield spawn(watchFetchCustomDocumentst);
}
